import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import React, { ChangeEvent, FunctionComponent } from 'react';
import { useOrdersContext } from '../contexts/OrdersContext';

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 150,
    marginTop: theme.spacing(2),
    maxWidth: 'none !important',
  },
  menuPaper: {
    maxHeight: 250,
  },
  values: {
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
}));

interface Props {
  mobile?: boolean;
}

const OrderTypeFilter: FunctionComponent<Props> = (props) => {
  const { orderTypes, orderType, setOrderType } = useOrdersContext();
  const classes = useStyles();

  const margin = !props.mobile ? 'normal' : 'dense';

  const handleOrderTypeChange = (event: ChangeEvent<{ value: unknown }>): void => {
    setOrderType(event.target.value as number);
  };

  return (
    <FormControl variant="outlined" className={classes.formControl} margin={margin} fullWidth>
      <InputLabel id="mall-label">Order Type</InputLabel>
      <Select
        label="Choose Mall"
        labelId="mall-select-label"
        id="mall-select"
        value={orderType}
        className={classes.values}
        onChange={handleOrderTypeChange}
        MenuProps={{
          classes: { paper: classes.menuPaper },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
        }}
      >
        {orderTypes.map((o) => (
          <MenuItem key={o.id} value={o.id}>
            {o.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default OrderTypeFilter;
